// PageUserProfile Component

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PageBase from '../page_base/page_base.jsx'
import UserProfileForm from '../../user/user_profile_form/user_profile_form.jsx'
import UserPasswordForm from '../../user/user_password_form/user_password_form.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import Acl from '../../../lib/acl.jsx'
import { upsertUserInStream } from '../page_chat/utils.js'
import { ProfileIcon } from '../../../common/layout/menu_icons/profile.jsx'

class PageUserProfile extends PageBase {
  constructor (props) {
    super(props, 'userprofile', 'user-profile', 'user-profile')

    this.state = {
      isLoading: true,
      dataDate: null,
      bPassword: false
    }

    this.data = {
      user: {}
    }

    this._references = {
      formemail: React.createRef(),
      pageHeader: React.createRef()
    }
  }

  componentDidMount () {
    this._getData()
  }

  renderContent () {
    return (
      <div className='page-userprofile'>
        {this._renderForm()}
      </div>
    )
  }

  /* renderHeader() {
    return (
      <PageHeaderUser title="user.profile.title" pageIdent="user-profile"
        onChangePage={this._onChangePage.bind(this)} ref={this._references.pageHeader} />
    );
  } */

  /* Event Handlers */
  _onSubmit (user, imageAvatar, bImageDeleted) {
    const userOld = this.data.user

    if (!app.isDemo) {
      this._saveUserTeam(
        user,
        imageAvatar,
        bImageDeleted,
        (err, _updateRes) => {
          if (err) {
            this._onError(null)
          } else {
            if (this._references.pageHeader.current) {
              this._references.pageHeader.current.showSuccess(
                'user.profile.msgSuccessContent',
                'user.profile.msgSuccessContent',
                true
              )
            }

            if (userOld.timezone !== user.timezone) {
              app.setTimezone(user.timezone)
            }

            if (userOld.language !== user.language) {
              app.changeLanguage(user.language)
              app.pageContainer.refresh()
            }
          }
        }
      )
    } else {
      this.showError('user.profile.errorUserDemoMsg')
    }
  }

  _onError (field) {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'user.profile.msgErrorTitle',
        field || 'user.profile.msgErrorContent',
        false
      )
    }
  }

  _onClickChangePassword () {
    if (!app.isDemo) {
      this.setState({ bPassword: true })
    } else {
      this.showError('user.profile.errorDemoMsg')
    }
  }

  _onClickProfile () {
    this.setState({ bPassword: false })
  }

  _validatePassword (email, oldPassword, newPassword) {
    const userParams = {
      query: {
        email: email,
        password: oldPassword
      }
    }

    app
      .service('/api/users/validatepassword')
      .find(userParams)
      .then(userRes => {
        if (userRes) {
          this._updatePassword(oldPassword, newPassword)
        } else {
          if (this._references.pageHeader.current) {
            this._references.pageHeader.current.showError(
              'user.profile.msgErrorTitle',
              'user.profile.msgErrorPassword',
              false
            )
          }
        }
      })
      .catch(err => {
        this._onError(err)
        app.debug('PageUserProfile: _validatePassword Error', err)
      })
  }

  _updatePassword (oldPassword, newPassword) {
    const params = {
      query: {
        $client: {
          passwordUpdate: true
        }
      }
    }

    app
      .service('/api/users')
      .patch(app.loggedInId, { password: newPassword, oldPassword }, params)
      .then(_updateRes => {
        if (this._references.pageHeader.current) {
          this._references.pageHeader.current.showSuccess(
            'user.profile.msgSuccessTitle',
            'user.profile.msgSuccessPassword',
            true
          )
        }
      })
      .catch(updateErr => {
        this._onError(null)
        app.debug('PageUserProfile: _updatePassword Error', updateErr)
      })
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataUser(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataUser (callback) {
    app.debug('PageUserProfile: _getDataUser [start]')

    const findParams = {
      query: {
        userId: app.loggedInId,
        teamId: app.getTeamId()
      }
    }

    app
      .service('/api/users/team')
      .find(findParams)
      .then(result => {
        if (result.data && result.data.length > 0) {
          this.data.user = result.data[0]
          callback(null)
        } else {
          callback('Invalid user details') // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(err => {
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (err) {
      app.debug('PageUserProfile: _onDataReceived Error', err)
    } else {
      app.debug('PageUserProfile: _onDataReceived [done]')
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _onShowPasswordError = () => {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'user.profile.msgErrorTitle',
        'user.profile.msgIncorrectPassword',
        false
      )
    }
  }

  _renderForm () {
    if (!this.state.bPassword) {
      const showLanguageDropdown = !(
        app.teamCountry === 'US' || app.teamCountry === 'UK'
      )

      return (
        <UserProfileForm
          user={this.data.user}
          onSubmit={this._onSubmit.bind(this)}
          onError={this._onError.bind(this)}
          showLanguageDropdown={showLanguageDropdown}
          onClickChangePassword={this._onClickChangePassword.bind(this)}
        />
      )
    } else if (this.state.bPassword) {
      return (
        <UserPasswordForm
          user={this.data.user}
          onSubmit={this._validatePassword.bind(this)}
          onError={this._onError.bind(this)}
          onShowPassWordError={this._onShowPasswordError} // eslint-disable-line react/jsx-handler-names
          onClickProfile={this._onClickProfile.bind(this)}
        />
      )
    }
  }

  _saveUserTeam (user, imageAvatar, bImageDeleted, callback) {
    app.debug('PageUserProfile: _saveUser [start]')
    const userData = {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      language: user.language,
      timezone: user.timezone
    }
    const params = {
      query: {
        $client: { imageAvatar: imageAvatar, imageDeleted: bImageDeleted }
      }
    }

    app
      .service('/api/users/team')
      .patch(this.data.user.id, userData, params)
      .then(async userTeamRes => {
        app.debug('PageUserProfile: _saveUser [done]')
        if (userTeamRes) {
          await upsertUserInStream(userTeamRes, userTeamRes.teamId)
          this.data.user = userTeamRes
          app.setLanguage(userTeamRes.language)
          app.setTimezone(userTeamRes.timezone)
          callback(null, userTeamRes)
        } else {
          callback({}, null) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(userTeamErr => {
        app.debug('PageUserProfile: _saveUserTeam Error', userTeamErr)
        callback(userTeamErr, null)
      })
  }

  /* Header Functions - START */
  renderHeader () {
    const tabsUser = [
      {
        ident: 'user-profile',
        title: 'user.overview.overview',
        showFavourite: true
      },
      {
        ident: 'user-schedule',
        title: 'user.schedule.schedule',
        showFavourite: true
      },
      {
        ident: 'user-skills',
        title: 'user.skills.skills',
        showFavourite: true
      },
      {
        ident: 'personal-setting',
        title: 'user.personal.settings',
        showFavourite: true
      }
    ]

    const tabs = []

    tabsUser.map((tabitem, _idx) => {
      if (Acl.isPageAllowed(tabitem.ident)) {
        tabs.push(tabitem)
      }
    })

    return (
      <PageHeader
        ref={this._references.pageHeader}
        title='user.profile.title'
        icon={<ProfileIcon width={20} />}
        activeTab='user-profile'
        favoriteTab={this._getUserFavoriteTab('user') || 'user-profile'}
        tabs={tabs}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('user', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions -END */
}

export default PageUserProfile
